module.exports = __webpack_public_path__ + "media/ru_ru_s2_Igor.07899cba.mp3";